// extracted by mini-css-extract-plugin
export default {"root":"HeadedBorderCard_root__v5yGh","header":"HeadedBorderCard_header__UilnX","headerLabel":"HeadedBorderCard_headerLabel__H0LCw"};